
export default {

    data() {
        return {
            // randomRoot: ''
            linkPage: '',
            isActive: this.isSamePage(),
            classList: {}
        }
    },

    props: {
        to: { type: String },

        activeClass: { type: String, default: '' },

        // Optional value object used to transit data from parent to child:
        // <parent> -> <core-drag-area> -> <child>
        data: Object
    },

    watch: {

        activeClass: function() {
            this.classList = {
                [this.activeClass]: isActive
            }
        }
    },

    created()
    {
        this._onChangePage = this._onChangePage.bind(this)
    },

    mounted()
    {
        this.isActive = this.isSamePage()
        this.eventHub.$on('page:change', this._onChangePage)
    },

    destroy()
    {
        this.eventHub.$off('page:change', this._onChangePage)
    },

    methods: {

        _onChangePage( pagePath )
        {
            this.isActive = pagePath === this.to
        },

        _click()
        {
            if (this.isActive)
            {
                this.$emit('same', this.$root.$children[0].currentPage)
            }
            else
            {
                this.$router.push(this.to)
            }
        },

        /*getCurrentPage()
        {
            return this.$root.$children[0].currentPage
        },*/

        isSamePage()
        {
            return this.$root.$children[0].currentPage === this.to
        }

        /*randomString(length){
            let text = "";
            const letters = "abcdefghijklmnopqrstuvwxyz0123456789";

            for( let i=0; i < length; i++ ){
                text += letters.charAt(Math.floor(Math.random() * letters.length));
            }

            return text;
        }*/
    }

}